/* eslint-disable no-misleading-character-class */
/* eslint-disable no-control-regex */
import { Switch } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import React, { useEffect, useState } from 'react'
import {
  Badge,
  Button,
  Dropdown,
  Image,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap'
import { FaSun } from 'react-icons/fa'
import { FaMoon } from 'react-icons/fa'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'

import ColetaClickstream from './components/clickstreamAnalise/clickstreamColeta.js'
import DropAcoesRelatorios from './components/dropAcoesRelatorios'
import DropPainel from './components/dropPainel'
import DropSeparadorLinha from './components/dropSeparadorLinha'
import AlertaConfirmacaoAcao from './components/ESims/AlertaModal/index.jsx'
import RenderModalBloqueioFinanceiro from './components/modalBloqueioFinanceiro'
import Mensagem from './components/painelMensagens/mensagem'
import DropFiltros from './components/pavFiltros/dropFiltros'
import BuscaArquivo from './components/pavFiltros/filtroArquivo'
import FiltroESimsDispositivos from './components/pavFiltros/FiltrosEsim/Dispositivos'
import FiltroESimsEstoque from './components/pavFiltros/FiltrosEsim/Estoque'
import FiltroSolicitacoesESims from './components/pavFiltros/FiltrosEsim/Solicitacao'
import FiltrosFaturasDispositivos from './components/pavFiltros/FiltrosFaturasDispositivos/index.jsx'
import FiltrosPainelAdmUsuarios from './components/pavFiltros/FiltrosPainelAdmUsuarios/index.jsx'
import FiltrosPortadoras from './components/pavFiltros/FiltrosPortadoras/index.jsx'
import FiltroSimcardsVirgens from './components/pavFiltros/FiltrosSimcardsVirgens'
import FiltroSolicitacoesSimcardsVirgens from './components/pavFiltros/FiltrosSolicitacaoSimcardsVirgens'
import FiltrosVirtueyesCliente from './components/pavFiltros/FiltrosVirtueyesCliente/index.jsx'
import { CustomTooltip } from './components/tooltip/index.jsx'
import { api_gateway } from './conexoes/api'
import './css/cabecalhoSistema.css'
import {
  atualizarAlertasCabecalho as atualizarAlertasCabecalhoFunc,
  atualizarMensagemCabecalhoSelecionada,
  atualizarMensagensCabecalho as atualizarMensagensCabecalhoFunc,
  conteudoBusca,
  expandirNavegacao,
  limpadorFiltros,
  limpouBusca,
  mudarBuscaArquivo,
  mudarFiltros,
  realizouBusca,
  revelarConfigurarGrupo,
  revelarExibirColunas,
  revelarMensagemCabecalhoSelecionada as revelarMensagemCabecalho,
  separadorLinhaBusca,
  verificadorBloqueioFinanceiro
} from './redux/actions/index'
import routers from './statics/routers.json'
import { useGlobal } from './stores/useGlobal.js'
import {
  alerta,
  configuracoes,
  dropdownDesativado,
  email,
  envelopeFechado,
  filtrarVerde,
  iconeBotaoBuscarPorArquivo,
  limpar,
  limparDesativado,
  lupa,
  lupaDesativado,
  menu,
  menuRecolhido,
  setaDropdown,
  setaDropdownDesativado
} from './utils/alternanciaIcones'
import decryptJWT, { RetornarParametro } from './utils/decryptJWT'
import { getTempFiltros } from './utils/filtros'
import { isPortal } from './utils/nivelCliente'

const placeholder = require('./busca.json')

const telaSemBusca = [
  'dashboardGeral',
  'clickstream',
  'dashboardSMS',
  'dashboardComsumoEHistorico',
  'financeiro',
  'Permissao',
  'cadastroOperadoraMultiCliente',
  'versionamento',
  'migracaoPlanoDashboard',
  'painelTutoriais',
  'versionamento-clientes'
]

const telaSemAcao = [
  'financeiroAlgarNivelTres',
  'mensagens',
  'cadastroPerfil',
  'solicitacaoClienteFornecedor',
  'dashboardFaturas',
  'dashboardGeral',
  'dashboardSMS',
  'dashboardComsumoEHistorico',
  'telaInicial',
  'acessoLog',
  'clickstream',
  'Permissao',
  'requestLog',
  'imeiLog',
  'con_solicitacao',
  'migracaoPlanoGerenciamento',
  'migracaoPlanoDashboard',
  'painelTutoriais',
  'versionamento-clientes'
]

const arrPaginasComRelatorios = [
  'dspDispositivos',
  'migracaoPlanoGerenciamento',
  'painelRelatorios',
  'pedidosSimcard',
  'fat_solicitacao',
  'fatFaturas',
  'fatDispositivos',
  'fatFebraban',
  'financeiro',
  'solicitacaoBloqueio',
  'solicitacaoOperadora',
  'virtueyesClientes',
  'envioSms',
  'con_solicitacao',
  'migracaoPlanoGerenciamento',
  'simcardsVirgens',
  'solicitacoesSimcardsVirgens',
  'portadoras',
  'eSimDevices',
  'eSimStock',
  'solicitacoesESims'
]

const arrPaginasComBuscaPorArquivo = [
  'dspDispositivos',
  'fatDispositivos',
  'fat_solicitacao',
  'con_solicitacao',
  'migracaoPlanoGerenciamento',
  'simcardsVirgens'
]

const excludeds = [
  'dashboardFaturas',
  'dashboardGeral',
  'dashboardSMS',
  'dashboardComsumoEHistorico',
  'telaInicial',
  'acessoLog',
  'clickstream',
  'Permissao',
  'requestLog',
  'imeiLog'
]

const TELAS_DASHBOARD = [
  'dashboardFaturas',
  'dashboardGeral',
  'dashboardSMS',
  'dashboardComsumoEHistorico'
]

const TELAS_EXPANDIR_SEPARADOR = [
  'telaInicial',
  'dspDispositivos',
  'migracaoPlanoGerenciamento',
  'fatDispositivos',
  'fat_solicitacao',
  'cadastroParceiro',
  'cadastroCliente',
  'fatFebraban',
  'moduloAutomacao',
  'usuarioCliente',
  'painelRelatorios',
  'con_solicitacao',
  'elemento',
  'modulo',
  'sistema',
  'tela',
  'usuario',
  'cadastroPermissionamento',
  'virtueyesClientes',
  'solicitacaoCliente',
  'simcardsVirgens',
  'solicitacoesSimcardsVirgens',
  'portadoras',
  'eSimDevices',
  'eSimStock',
  'novoPedidoSMS',
  'faturasPedidos',
  'tabelaPedidosSms'
]

function LinhaDivisoria() {
  return (
    <div className="campo-select-divisor-cor-1 menu-dropdown-divisor-cabecalho-sistema" />
  )
}

async function pegarSeparador(codigo) {
  const separador = await api_gateway
    .get('/m1/consultar/preferencias?cd_pav_usuario=' + codigo)
    .then(function (resposta) {
      return resposta.data.dados[0]
    })
    .catch(function (erro) {
      throw erro.stack
    })
  return separador
}

function RenderModalBuscaPorArquivo({
  renderizarBuscaArquivo,
  setRenderizarBuscaArquivo,
  setNomeArquivo,
  enviarBuscaArquivo,
  fazerColetaClick
}) {
  return (
    <div
      id="filtro-por-arquivo"
      className="drop-filtros-lista-submenu-simcard dropdown-desativado-filtros"
    >
      {renderizarBuscaArquivo && (
        <div className="componente-modal-overlay-filtro-arquivo">
          <div className="componente-modal-filtro-arquivo-container">
            <BuscaArquivo
              setNomeArquivo={setNomeArquivo}
              renderizar={renderizarBuscaArquivo}
              setRenderizar={setRenderizarBuscaArquivo}
              enviarBuscaArquivo={enviarBuscaArquivo}
              handleFuncaoEstadosRedux={fazerColetaClick}
            />
          </div>
        </div>
      )}
    </div>
  )
}

function BotaoBuscaPorArquivo({
  setRenderizarBuscaArquivo,
  iconeBotaoBuscarPorArquivo
}) {
  return (
    <CustomTooltip text="Buscar por arquivo">
      <div className="coluna-barra-de-pesquisa-3">
        <Button
          className="botao-barra-pesquisa-limpar fundo-cor-7"
          onClick={() => setRenderizarBuscaArquivo(true)}
        >
          <Image
            className="icone-botao-barra-pesquisa-limpar"
            src={iconeBotaoBuscarPorArquivo()}
          />
        </Button>
      </div>
    </CustomTooltip>
  )
}

function CabecalhoSistema() {
  const [opened, { open, close }] = useDisclosure(false)

  const isTemaEscuro = localStorage.getItem('tema') === 'escuro'
  const {
    setToggleTema: setToggleTemaZustand,
    revelarDadosCliente: revelarDadosClienteZustand,
    setRevelarDadosCliente: setRevelarDadosClienteZustand,
    busca: buscaZustand,
    setBusca: setBuscaZustand,
    setBuscaArquivo: setBuscaArquivoZustand,
    confirmacaoAcao,
    setConfirmacaoAcao,
    linhasSelecionadas,
    selecionarParqueInteiro,
  } = useGlobal()
  //FIXME: Medida provisória para controlar ações de linhas eSIMs
  const handleCloseConfirmacaoAcao = () =>
    setConfirmacaoAcao({
      open: false,
      acaoRedux: null,
      callback: null,
      acao: null
    })

  const handleConfirmacaoAcao = () => {
    if (confirmacaoAcao.callback) {
      confirmacaoAcao.callback()
    }
    handleCloseConfirmacaoAcao()
  }

  const portalCliente = isPortal()

  const [revelarSeperadorLinha, setRevelarSeperadorLinha] = useState(false)
  const [revelarDropAcoes, setRevelarDropAcoes] = useState(false)
  const [revelarDropRelatorios, setRevelarDropRelatorios] = useState(false)

  const [revelarDropFiltros, setRevelarDropFiltros] = useState(false)
  const [renderizarBuscaArquivo, setRenderizarBuscaArquivo] = useState(false)
  const [nomeArquivo, setNomeArquivo] = useState('')
  const [pesquisa, setPesquisa] = useState('')
  const [mensagensNaoLidas, setMensagensNaoLidas] = useState([])
  const [contadorMensagensNaoLidas, setContadorMensagensNaoLidas] = useState(0)
  const [alertasNaoLidos, setAlertasNaoLidos] = useState([])
  const [contadorAlertasNaoLidos, setContadorAlertasNaoLidos] = useState(0)
  const [renderizarAlertas, setRenderizarAlertas] = useState(false)
  const [renderizarMensagens, setRenderizarMensagens] = useState(false)
  const [renderizarConfiguracoes, setRenderizarConfiguracoes] = useState(false)
  const [
    controleRenderizacaoMenuMensagens,
    setControleRenderizacaoMenuMensagens
  ] = useState(false)

  const [revelarDropAcoesRelatorios, setRevelarDropAcoesRelatorios] =
    useState(false)
  const [showTooltipPesquisa, setShowTooltipPesquisa] = useState(false)
  const [trocandoTema, setTrocandoTema] = useState(false)

  const history = useHistory()

  const handleTrocarTema = async () => {
    if (trocandoTema) return

    setTrocandoTema(true)

    try {
      const novoTema = isTemaEscuro ? 'claro' : 'escuro'
      localStorage.setItem('tema', novoTema)
      setToggleTemaZustand((prev) => !prev)

      // Pequeno delay para dar feedback visual
      await new Promise((resolve) => setTimeout(resolve, 300))
    } finally {
      setTrocandoTema(false)
    }
  }

  const getCodigo = () => decryptJWT('codigo')

  const desabilitarAcoes = useSelector(
    (state) => state.manejadorState.desabilitarAcoes
  )
  const desabilitarFiltros = useSelector(
    (state) => state.manejadorState.desabilitarFiltros
  )
  let conteudo = useSelector((state) => state.manejadorState.conteudoBusca)
  let estadoExpansaoNavegacao = useSelector(
    (state) => state.manejadorState.expandirNavegacao
  )
  let atualizarMensagensCabecalho = useSelector(
    (state) => state.mensagensState.atualizarMensagensCabecalho
  )
  let revelarMensagemCabecalhoSelecionada = useSelector(
    (state) => state.mensagensState.revelarMensagemCabecalhoSelecionada
  )
  let bloqueioFinanceiro = useSelector(
    (state) => state.manejadorState.verificadorBloqueioFinanceiro
  )
  let separadorLinha = useSelector(
    (state) => state.manejadorState.separadorLinha
  )
  const permissaoElementoAcao = useSelector(
    (state) => state.permissaoState.permissaoElementoAcao
  )
  const permissaoExibirColunas = useSelector(
    (state) =>
      state.permissaoState.permissaoElementoOutrosConfiguracoesExibirColunas
  )
  const permissaoConfigurarGrupos = useSelector(
    (state) =>
      state.permissaoState.permissaoElementoOutrosConfiguracoesConfigurarGrupos
  )
  const permissaoVisualizarMensagens = useSelector(
    (state) =>
      state.permissaoState.permissaoElementoOutrosMensagensVisualizarMensagens
  )
  let atualizarAlertaCabecalho = useSelector(
    (state) => state.mensagensState.atualizarAlertaCabecalho
  )
  let revelarAlertaCabecalhoSelecionado = useSelector(
    (state) => state.mensagensState.revelarAlertaCabecalhoSelecionada
  )
  const buscaArquivo = useSelector(
    (state) => state.buscaArquivoState.buscaArquivo
  )
  let RevelarBuscarFiltro = useSelector(
    (state) => state.manejadorState.RevelarBuscarEFiltro
  )
  let expansaoNavegacaoHover = useSelector(
    (state) => state.manejadorState.expandirNavegacaoHover
  )

  const despacho = useDispatch()
  const manejador = useSelector((state) => state.manejadorState.manejador)

  useEffect(() => {
    close()
  }, [close])

  useEffect(() => {
    exibirBarraDadosCliente()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revelarDadosClienteZustand])

  function exibirBarraDadosCliente() {
    const clienteOriginal = Number(decryptJWT('clienteOriginal'))
    const codigoCliente = Number(decryptJWT('codigoCliente'))
    const isVirtueyesCliente =
      clienteOriginal === 1 && clienteOriginal === codigoCliente

    if (isVirtueyesCliente) {
      handleRevelarDadosCliente(false)
      return
    }

    handleRevelarDadosCliente(revelarDadosClienteZustand)
  }

  const handleAbrirFiltros = () => {
    const currentPath = window.location.pathname

    const pathsToOpen = new Set([
      routers.simcardsEmBranco,
      routers.solicitacoesSimcardsEmBranco,
      routers.solicitacoesESims,
      routers.portadoras,
      routers.painelUsuarios,
      routers.faturasDispositivos,
      routers.virtueyesClientes,
      routers.eSimDevices,
      routers.eSimStock
    ])

    if (pathsToOpen.has(currentPath)) {
      open()
    } else {
      setRevelarDropFiltros((prev) => !prev)
    }
  }

  const menuRelatorios = manejador !== 'painelRelatorios' || !portalCliente

  function toggleRevelarDropAcoes(value, titulo = 'Ações') {
    if (titulo === 'Relatórios') {
      setRevelarDropRelatorios(value)
    } else {
      setRevelarDropAcoes(value)
    }
  }

  function toggleRevelarDropFiltros(value) {
    setRevelarDropFiltros(value)
  }

  useEffect(() => {
    if (!buscaArquivo?.chave && buscaArquivo != '') {
      setNomeArquivo('')
    }
  }, [buscaArquivo])

  useEffect(() => {
    async function handlerPegarSeparador() {
      const { busca_separador } = await pegarSeparador(getCodigo())
      despacho(separadorLinhaBusca(busca_separador))
    }

    handlerPegarSeparador()
  }, [despacho])

  useEffect(() => {
    if (!manejador) return

    if (manejador != 'dspDispositivos') {
      despacho(verificadorBloqueioFinanceiro(false))
    }
  }, [despacho, manejador])

  useEffect(() => {
    if (!manejador) return

    buscaPushNaolidas()
    buscaMensagensNaoLidas()
    buscaAlertasNaoLidos()
    RetornarParametro()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    manejador,
    conteudo,
    atualizarMensagensCabecalho,
    atualizarAlertaCabecalho,
    buscaZustand
  ])

  useEffect(() => {
    if (!manejador) return

    if (buscaArquivo?.chave) handleLimparPesquisa()
    else
      manejador === 'dspDispositivos' ? setPesquisa(pesquisa) : setPesquisa('')

    despacho(conteudoBusca(''))
    setBuscaZustand('')

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manejador])

  function handleAbrirGridMensagens() {
    setPesquisa('')
    despacho(conteudoBusca(''))
    setBuscaZustand('')
    setRenderizarMensagens(false)
  }

  useEffect(() => {
    if (Notification.permission === 'default') {
      Notification.requestPermission()
    }
  }, [])

  const buscaPushNaolidas = () => {
    api_gateway
      .get('/m1/consultar/notificacao')
      .then((response) => {
        const { data } = response

        if (
          data &&
          Array.isArray(data.dados) &&
          Notification.permission === 'granted'
        ) {
          //* gera um array de promises com todas notificações
          const promises = data.dados.map((msg) => {
            return new Promise((resolve) => {
              const titulo = msg.titulo || 'Nova mensagem'
              const mensagem = msg.resumo || 'Você recebeu uma mensagem.'

              const notif = new Notification(titulo, {
                body: mensagem,
                icon: '/icones/v_veye.svg'
              })

              notif.onshow = () => resolve(msg.id)
            })
          })

          //* espera todas as notificações serem mostradas
          Promise.all(promises).then((ids) => {
            //* atualiza em lote as notificações mostradas
            enviarNotificacoesLidas(ids)
          })
        }
      })
      .catch((err) => {
        console.error('Erro ao buscar notificações:', err)
      })
  }

  async function enviarNotificacoesLidas(ids) {
    if (!ids || ids.length === 0) return

    try {
      await api_gateway.post('/m1/alterar/notificacao', { id: ids, lido: 1 })
    } catch (err) {
      console.error('Erro ao marcar notificações como lidas:', err)
    }
  }

  function buscaMensagensNaoLidas() {
    api_gateway
      .get(
        '/m1/consultar/mensagem?contar=true&fl_lido=0&msg1.cd_msg_mensagem_plataforma_origem=1&cd_mensagem_tipo=2&cd_pav_usuario_destinatario=' +
        getCodigo()
      )
      .then((response) => {
        const { data } = response
        if (data.status == 200) {
          setContadorMensagensNaoLidas(data.dados[0].CONTADOR)
          if (data.dados[0].CONTADOR > 0) {
            api_gateway
              .get(
                '/m1/consultar/mensagem?paginaAtual=0&carregarLimit=5&fl_lido=0&msg1.cd_msg_mensagem_plataforma_origem=1&cd_mensagem_tipo=2&cd_pav_usuario_destinatario=' +
                getCodigo()
              )
              .then((response) => {
                const { data } = response
                if (data.status == 200) setMensagensNaoLidas(data.dados)
              })
              .catch((err) => {
                console.error('Erro ao buscar detalhes das mensagens:', err)
              })
          } else {
            setMensagensNaoLidas([])
          }
        }
      })
      .catch((err) => {
        console.error('Erro ao buscar mensagens não lidos:', err)
      })
  }

  function buscaAlertasNaoLidos() {
    api_gateway
      .get(
        '/m1/consultar/mensagem?contar=true&fl_lido=0&msg1.cd_msg_mensagem_plataforma_origem=2&cd_mensagem_tipo=2&cd_pav_usuario_destinatario=' +
        getCodigo()
      )
      .then((response) => {
        const { data } = response
        setContadorAlertasNaoLidos(data.dados[0].CONTADOR)
        if (data.dados[0].CONTADOR > 0) {
          api_gateway
            .get(
              '/m1/consultar/mensagem?paginaAtual=0&carregarLimit=5&fl_lido=0&msg1.cd_msg_mensagem_plataforma_origem=2&cd_mensagem_tipo=2&cd_pav_usuario_destinatario=' +
              getCodigo()
            )
            .then((response) => {
              const { data } = response
              if (data.status == 200) setAlertasNaoLidos(data.dados)
            })
            .catch((err) => {
              console.error('Erro ao buscar detalhes dos alertas:', err)
            })
        } else {
          setAlertasNaoLidos([])
        }
      })
      .catch((err) => {
        console.error('Erro ao buscar alertas não lidos:', err)
      })
  }

  async function abrirMensagem(mensagem) {
    if (mensagem.ds_msg_mensagem_origem == 'Plataforma')
      setRenderizarMensagens(false)
    else setRenderizarAlertas(false)

    const cd_msg_mensagem = mensagem.cd_msg_mensagem
    const bodyAlteracao = {
      condicao: {
        cd_msg_mensagem_plataforma: cd_msg_mensagem
      },
      dados: {
        fl_lido: 1
      }
    }

    await api_gateway.post('/m1/alterar/mensagem', bodyAlteracao)
    despacho(atualizarMensagensCabecalhoFunc(!atualizarMensagensCabecalho))
    despacho(atualizarAlertasCabecalhoFunc(!atualizarAlertaCabecalho))
    despacho(atualizarMensagemCabecalhoSelecionada(mensagem))
    despacho(revelarMensagemCabecalho(true))
  }

  function handlePesquisar() {
    //REGEX PRA ELIMINAR NON-PRINTABLE CHARACTERS
    var regex =
      /[\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u037F-\u0383\u038B\u038D\u03A2\u0528-\u0530\u0557\u0558\u0560\u0588\u058B-\u058E\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08A1\u08AD-\u08E3\u08FF\u0978\u0980\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0C00\u0C04\u0C0D\u0C11\u0C29\u0C34\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5A-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C81\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D01\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5F\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F5-\u13FF\u169D-\u169F\u16F1-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191D-\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7-\u1CFF\u1DE7-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BB-\u20CF\u20F1-\u20FF\u218A-\u218F\u23F4-\u23FF\u2427-\u243F\u244B-\u245F\u2700\u2B4D-\u2B4F\u2B5A-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E3C-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FCD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA698-\uA69E\uA6F8-\uA6FF\uA78F\uA794-\uA79F\uA7AB-\uA7F7\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FC-\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9E0-\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAA7C-\uAA7F\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F-\uABBF\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE27-\uFE2F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]/g

    despacho(realizouBusca(true))
    despacho(conteudoBusca(pesquisa.replace(regex, '')))
    setBuscaZustand(pesquisa.replace(regex, ''))

    if (separadorLinha === 'espaco' || separadorLinha === 'enter') {
      separadorLinha = ' '
    }
    if (manejador === 'telaInicial') {
      const str = pesquisa.replace(regex, '')
      const arr = str.split(separadorLinha)
      arr[0].length > 11
        ? despacho(mudarFiltros({ ICCID: arr }))
        : despacho(mudarFiltros({ LINHA: arr }))
      despacho(limpadorFiltros(false))
      history.push('/veye/dispositivos')
    }
  }

  function botaoPressionado(event) {
    if (event.key === 'Enter') {
      handlePesquisar()
    }
  }

  const limparBuscaPorArquivo = () => despacho(mudarBuscaArquivo({}))

  function handleLimparPesquisa() {
    setPesquisa('')
    setNomeArquivo('')
    limparBuscaPorArquivo()
    despacho(limpouBusca(true))
    if (nomeArquivo && nomeArquivo !== '') setNomeArquivo('')

    despacho(conteudoBusca(''))

    // * SET ZUSTAND
    setBuscaZustand('')
    setBuscaArquivoZustand({})
  }

  const temConteudoBusca = () => {
    const temPesquisa = pesquisa && pesquisa.trim() !== ''
    const temBuscaZustand = buscaZustand && buscaZustand.trim() !== ''
    const temBuscaArquivo = buscaArquivo?.chave || (buscaArquivo && Object.keys(buscaArquivo).length > 0 && buscaArquivo !== '')
    const temNomeArquivo = nomeArquivo && nomeArquivo.trim() !== ''

    return temPesquisa || temBuscaZustand || temBuscaArquivo || temNomeArquivo
  }

  const handleRevelarDadosCliente = (value) => {
    setRevelarDadosClienteZustand(value)
  }

  const rendersMensagensNaoLidas = () =>
    mensagensNaoLidas.map((mensagem) => (
      <Dropdown.Item
        key={mensagem.ds_titulo}
        className="item-dropdown-mensagem-cabecalho-sistema campo-select-opcao-1"
        onClick={() => abrirMensagem(mensagem)}
      >
        <div className="container-email-dropdown-mensagem-cabecalho-sistema">
          <div className="container-elipse-mensagem-cabecalho-sistema">
            {mensagem.ds_mensagem_nivel == 'Atenção' && (
              <div className="elipse-verde-mensagem" />
            )}
            {mensagem.ds_mensagem_nivel == 'Crítico' && (
              <div className="elipse-amarelo-mensagem" />
            )}
            {mensagem.ds_mensagem_nivel == 'Urgente' && (
              <div className="elipse-vermelho-mensagem" />
            )}
          </div>
          <div className="container-envelope-mensagem-cabecalho-sistema">
            <Image
              className="icone-email-dropdown-mensagem-cabecalho-sistema"
              src={envelopeFechado()}
            />
          </div>
          <div className="container-email-dropdown-mensagem-cabecalho-sistema-2">
            <div className="container-título-email-dropdown-mensagem-cabecalho-sistema">
              <p className="titulo-email-dropdown-mensagem-cabecalho-sistema fonte-cor-1">
                {' '}
                {mensagem.ds_titulo.length > 18
                  ? mensagem.ds_titulo.substring(0, 18) + '...'
                  : mensagem.ds_titulo}
                <p className="minuto-email-dropdown-mensagem-cabecalho-sistema fonte-cor-1">
                  {' '}
                  {mensagem.ds_tempo_decorrido}
                </p>{' '}
              </p>
            </div>
            <div className="container-descricao-email-dropdown-mensagem-cabecalho-sistema">
              <p className="descricao-email-dropdown-mensagem-cabecalho-sistema fonte-cor-1">
                {mensagem.tx_texto.replace(/(<([^>]+)>)/gi, '').length > 25
                  ? mensagem.tx_texto
                    .replace(/(<([^>]+)>)/gi, '')
                    .substring(0, 25) + '...'
                  : mensagem.tx_texto.replace(/(<([^>]+)>)/gi, '')}
              </p>
            </div>
          </div>
        </div>
        <div className="campo-select-divisor-cor-1 menu-dropdown-divisor-cabecalho-sistema-2" />
      </Dropdown.Item>
    ))

  const rendersAlertasNaoLidos = () =>
    alertasNaoLidos.map((alerta) => (
      <Dropdown.Item
        key={alerta.ds_titulo}
        className="item-dropdown-mensagem-cabecalho-sistema campo-select-opcao-1"
        onClick={() => abrirMensagem(alerta)}
      >
        <div className="container-email-dropdown-mensagem-cabecalho-sistema">
          <div className="container-elipse-mensagem-cabecalho-sistema">
            {alerta.ds_alerta_nivel == 'Atenção' && (
              <div className="elipse-verde-mensagem" />
            )}
            {alerta.ds_alerta_nivel == 'Crítico' && (
              <div className="elipse-amarelo-mensagem" />
            )}
            {alerta.ds_alerta_nivel == 'Urgente' && (
              <div className="elipse-vermelho-mensagem" />
            )}
          </div>
          <div className="container-envelope-mensagem-cabecalho-sistema">
            <Image
              className="icone-email-dropdown-mensagem-cabecalho-sistema"
              src={envelopeFechado()}
            />
          </div>
          <div className="container-email-dropdown-mensagem-cabecalho-sistema-2">
            <div className="container-título-email-dropdown-mensagem-cabecalho-sistema">
              <p className="titulo-email-dropdown-mensagem-cabecalho-sistema fonte-cor-1">
                {' '}
                {alerta.ds_titulo.length > 18
                  ? alerta.ds_titulo.substring(0, 18) + '...'
                  : alerta.ds_titulo}
                <p className="minuto-email-dropdown-mensagem-cabecalho-sistema fonte-cor-1">
                  {' '}
                  {alerta.ds_tempo_decorrido}
                </p>{' '}
              </p>
            </div>
            <div className="container-descricao-email-dropdown-mensagem-cabecalho-sistema">
              <p className="descricao-email-dropdown-mensagem-cabecalho-sistema fonte-cor-1">
                {alerta.tx_texto.replace(/(<([^>]+)>)/gi, '').length > 25
                  ? alerta.tx_texto
                    .replace(/(<([^>]+)>)/gi, '')
                    .substring(0, 25) + '...'
                  : alerta.tx_texto.replace(/(<([^>]+)>)/gi, '')}
              </p>
            </div>
          </div>
        </div>
        <div className="campo-select-divisor-cor-1 menu-dropdown-divisor-cabecalho-sistema-2" />
      </Dropdown.Item>
    ))

  function handleRevelarMensagens(revelar) {
    if (revelar && controleRenderizacaoMenuMensagens) {
      setRenderizarMensagens(true)
    }
    if (!controleRenderizacaoMenuMensagens) {
      buscaMensagensNaoLidas()
    }
  }

  function handleRevelarAlertas(revelar) {
    if (revelar) {
      setRenderizarAlertas(true)
    }
  }

  function HandleRevelarConfigurarGrupo() {
    despacho(revelarConfigurarGrupo(true))
    setRenderizarConfiguracoes(false)
  }

  function HandleRevelarExibirColunas() {
    despacho(revelarExibirColunas(true))
    setRenderizarConfiguracoes(false)
  }

  if (
    (revelarDropAcoes === true || revelarDropRelatorios === true) &&
    !excludeds.includes(manejador)
  ) {
    if (!revelarDropAcoesRelatorios) setRevelarDropAcoesRelatorios(true)
  } else {
    if (revelarDropAcoesRelatorios) setRevelarDropAcoesRelatorios(false)
  }

  const DropAcoesRelatoriosWrapper = React.memo(({ titulo, show, setRevelarDrop, toggleRevelarDropAcoes, manejador }) => {
    return (
      <>
        <div
          key={`drop-${titulo}-${manejador}`}
          style={{
            display: show ? 'block' : 'none'
          }}
        >
          <DropAcoesRelatorios
            titulo={titulo}
            className="posicionador-menu-filtros"
            setRevelarDropAcoes={setRevelarDrop}
            toggleRevelarDropAcoes={(v) => toggleRevelarDropAcoes(v, titulo)}
          />
        </div>
        {show && (
          <div className="componente-modal-overlay-cabecalho" />
        )}
      </>
    )
  }, (prevProps, nextProps) => {
    return (
      prevProps.show === nextProps.show &&
      prevProps.manejador === nextProps.manejador &&
      prevProps.titulo === nextProps.titulo
    )
  })

  DropAcoesRelatoriosWrapper.displayName = 'DropAcoesRelatoriosWrapper'

  function renderAcoesOuRelatorios(titulo) {
    if (manejador === 'versionamento') return

    const tituloAcoes = titulo === 'Ações'
    const tituloRelatorios = titulo === 'Relatórios'
    const setRevelarDrop = tituloRelatorios
      ? setRevelarDropRelatorios
      : setRevelarDropAcoes
    const revelarDrop = tituloRelatorios
      ? revelarDropRelatorios
      : revelarDropAcoes

    return (
      <div className="container-botao-filtros-cabecalho-sistema">
        {bloqueioFinanceiro && (
          <OverlayTrigger
            delay={{ show: 500, hide: 250 }}
            placement="bottom"
            overlay={
              <Tooltip id="tooltip-bottom" className="tooltip-busca">
                Cliente bloqueado
              </Tooltip>
            }
          >
            <Button
              className="botao-filtros-acoes-cabecalho-sistema-desativado fundo-cor-5"
              data-place="bottom"
              data-tip={
                desabilitarAcoes
                  ? 'Selecione uma linha para efetuar uma ação.'
                  : ''
              }
            >
              <span className="label-filtros-acoes-cabecalho-sistema-desativado">
                {titulo}
              </span>
              <Image
                className="icone-acoes-cabecalho-sistema-desativado"
                src={dropdownDesativado()}
              />
            </Button>
          </OverlayTrigger>
        )}

        {!portalCliente &&
          !tituloRelatorios &&
          TELAS_DASHBOARD.includes(manejador) && (
            <>
              {revelarDrop === true ? (
                <>
                  <DropPainel
                    className="posicionador-menu-filtros"
                    setRevelarDropAcoes={setRevelarDropAcoes}
                    toggleRevelarDropAcoes={toggleRevelarDropAcoes}
                  />
                  <div className="componente-modal-overlay-cabecalho" />
                </>
              ) : (
                <Button
                  className="botao-filtros-acoes-cabecalho-sistema fundo-cor-7"
                  data-place="bottom"
                  onClick={() => {
                    setRevelarDropAcoes(!revelarDrop)
                    ColetaClickstream(1067) /*dropPainel*/
                  }}
                >
                  <span
                    htmlFor="painel"
                    className="label-filtros-acoes-cabecalho-sistema fonte-cor-1"
                  >
                    Painel
                  </span>
                  <Image
                    className="icone-acoes-cabecalho-sistema-desativado"
                    src={setaDropdown()}
                  />
                </Button>
              )}
            </>
          )}

        {!bloqueioFinanceiro &&
          revelarDrop === false &&
          ((tituloAcoes && !telaSemAcao.includes(manejador)) ||
            (tituloRelatorios &&
              arrPaginasComRelatorios.includes(manejador))) && (
            <Button
              disabled={permissaoElementoAcao}
              className="botao-filtros-acoes-cabecalho-sistema fundo-cor-7"
              data-place="bottom"
              data-tip={
                desabilitarAcoes
                  ? 'Selecione uma linha para efetuar uma ação.'
                  : ''
              }
              onClick={() => {
                ColetaClickstream(63) && setRevelarDrop(!revelarDrop)
              }}
            >
              <span
                className={`label-filtros-acoes-cabecalho-sistema ${tituloRelatorios ? 'margem-botao-relatorios' : ''
                  } fonte-cor-1`}
              >
                {titulo}
              </span>
              <Image
                className="icone-acoes-cabecalho-sistema-desativado"
                src={setaDropdown()}
              />
            </Button>
          )}

        {/* renderiza as opções do menu ações */}
        <DropAcoesRelatoriosWrapper
          titulo={titulo}
          show={
            revelarDropAcoesRelatorios &&
            ((revelarDropAcoes && tituloAcoes) ||
              (revelarDropRelatorios && !tituloAcoes))
          }
          setRevelarDrop={tituloRelatorios ? setRevelarDropRelatorios : setRevelarDropAcoes}
          toggleRevelarDropAcoes={toggleRevelarDropAcoes}
          manejador={manejador}
        />
      </div>
    )
  }

  const enviarBuscaArquivo = (event, filtro_arquivo) => {
    let tempBuscaArquivo = getTempFiltros(event?.target, filtro_arquivo)

    setBuscaArquivoZustand(tempBuscaArquivo)
    despacho(mudarBuscaArquivo(tempBuscaArquivo))
    despacho(realizouBusca(true))
    setRenderizarBuscaArquivo(false)
  }

  function fazerColetaClick() {
    if (manejador === 'fatDispositivos') {
      ColetaClickstream(1254) /*fatFaturasDispositivosDropFiltrosFiltrar*/
    } else if (manejador === 'fat_solicitacao') {
      ColetaClickstream(1235) /*fatSolicitacoesTabelaDropFiltrosFiltrar*/
    }
  }

  const paginaComBuscaPorArquivo =
    arrPaginasComBuscaPorArquivo.indexOf(manejador) > -1

  const telaSemFiltro = [
    'solicitacaoBackoffice',
    'cadImportacaoDeLinhas',
    'painelRelatorios',
    'pedidoImporta',
    'cadastroPerfil',
    'relatorios',
    'faturasOperadoras',
    'faturasServicos',
    'faturasFornecedores',
    'financeiro',
    'telaInicial',
    'clickstream',
    'dashboardSMS',
    'dashboardComsumoEHistorico',
    'Permissao',
    'requestLog',
    'acessoLog',
    'faturasConciliacao',
    'fatEmpresa',
    'cadastroOperadoraMultiCliente',
    'versionamento',
    'fatFebraban',
    'cadastroParceiro',
    'cadastroPermissionamento',
    'migracaoPlanoDashboard',
    'painelTutoriais',
    'versionamento-clientes'
  ].includes(manejador)

  const esconderFiltros =
    (!RevelarBuscarFiltro, telaSemFiltro || desabilitarFiltros === true)

  const expandirDropDownSeparadorBusca =
    revelarSeperadorLinha && TELAS_EXPANDIR_SEPARADOR.includes(manejador)

  return (
    <>
      {opened && manejador === 'simcardsVirgens' && (
        <FiltroSimcardsVirgens close={close} opened={opened} />
      )}
      {opened && manejador === 'solicitacoesSimcardsVirgens' && (
        <FiltroSolicitacoesSimcardsVirgens close={close} opened={opened} />
      )}
      {opened && manejador === 'solicitacoesESims' && (
        <FiltroSolicitacoesESims close={close} opened={opened} />
      )}
      {opened && manejador === 'portadoras' && (
        <FiltrosPortadoras close={close} opened={opened} />
      )}

      {opened && manejador === 'fatDispositivos' && (
        <FiltrosFaturasDispositivos close={close} opened={opened} />
      )}
      {opened && manejador === 'usuario' && (
        <FiltrosPainelAdmUsuarios close={close} opened={opened} />
      )}
      {opened && manejador === 'virtueyesClientes' && (
        <FiltrosVirtueyesCliente close={close} opened={opened} />
      )}
      {opened && manejador === 'eSimDevices' && (
        <FiltroESimsDispositivos close={close} opened={opened} />
      )}
      {opened && manejador === 'eSimStock' && (
        <FiltroESimsEstoque close={close} opened={opened} />
      )}
      {/* Para cliente bloqueado: mostrar quando loga, e nas páginas Dispositivos e Dispositivos Fatura*/}
      <RenderModalBloqueioFinanceiro manejador={manejador} />

      {/* FIXME: Medida provisória para controlar ações de linhas eSIMs */}
      {manejador === 'dspDispositivos' && confirmacaoAcao.open && (
        <AlertaConfirmacaoAcao
          opened={confirmacaoAcao.open}
          acao={confirmacaoAcao.acao}
          parqueTodo={selecionarParqueInteiro}
          linhasSelecionadas={linhasSelecionadas}
          onClose={handleCloseConfirmacaoAcao}
          onConfirm={handleConfirmacaoAcao}
        />
      )}
      <RenderModalBuscaPorArquivo
        renderizarBuscaArquivo={renderizarBuscaArquivo}
        setRenderizarBuscaArquivo={setRenderizarBuscaArquivo}
        setNomeArquivo={setNomeArquivo}
        enviarBuscaArquivo={enviarBuscaArquivo}
        fazerColetaClick={fazerColetaClick}
      />
      <div className="container-cabecalho-sistema">
        <div className="grupo-cabecalho-sistema-1">
          <Button
            className="botao-alternar-navegacao-sistema"
            onClick={() =>
              despacho(expandirNavegacao(!estadoExpansaoNavegacao))
            }
          >
            <Image
              className="icone-botao-alternar-navegacao-sistema"
              src={
                estadoExpansaoNavegacao && expansaoNavegacaoHover
                  ? menu()
                  : menuRecolhido()
              }
            />
          </Button>
        </div>
        <div className="grupo-cabecalho-sistema-2">
          {/* "financeiro" - talvez vai ter que mecher aqui */}
          <div className="container-barra-de-pesquisa-cabecalho-sistema">
            {telaSemBusca.includes(manejador) || !RevelarBuscarFiltro ? (
              <>
                <div className="coluna-barra-de-pesquisa-1">
                  <Button className="botao-barra-pesquisa-pesquisar-desativado fundo-cor-5">
                    <Image
                      className="icone-botao-barra-pesquisa-pesquisar"
                      src={lupaDesativado()}
                    />
                  </Button>
                </div>
                <div className="coluna-barra-de-pesquisa-2">
                  <input
                    disabled
                    className="campo-barra-pesquisa-cabecalho-sistema-desativado fonte-cor-1 fundo-cor-5"
                    type="text"
                    placeholder={placeholder[manejador]}
                  />
                </div>
                <div className="coluna-barra-de-pesquisa-3">
                  <Button className="botao-barra-pesquisa-limpar-desativado fundo-cor-5">
                    <Image
                      className="icone-botao-barra-pesquisa-limpar"
                      src={limparDesativado()}
                    />
                  </Button>
                </div>
                <div className="coluna-barra-de-pesquisa-4">
                  <Button className="botao-barra-pesquisa-dropdown-desativado fundo-cor-5">
                    <Image
                      className="icone-botao-barra-pesquisa-dropdown"
                      src={setaDropdownDesativado()}
                    />
                  </Button>
                  {expandirDropDownSeparadorBusca && (
                    <>
                      <DropSeparadorLinha
                        setRevelarSeperadorLinha={setRevelarSeperadorLinha}
                        revelarSeperadorLinha={revelarSeperadorLinha}
                        className="posicionador-menu-filtros"
                      />
                    </>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="coluna-barra-de-pesquisa-1">
                  <CustomTooltip text="Pesquisar">
                    <Button
                      name="busca-geral"
                      className="botao-barra-pesquisa-pesquisar fundo-cor-7"
                      onClick={() => {
                        if (pesquisa) handlePesquisar()
                      }}
                      onKeyDown={(e) => botaoPressionado(e)}
                    >
                      <Image
                        className="icone-botao-barra-pesquisa-pesquisar"
                        src={lupa()}
                      />
                    </Button>
                  </CustomTooltip>
                </div>
                <div className="coluna-barra-de-pesquisa-2">
                  <CustomTooltip
                    text="Digite algo a ser pesquisado"
                    visible={pesquisa === '' && showTooltipPesquisa}
                  >
                    <input
                      name="busca-geral"
                      onKeyDown={(e) => botaoPressionado(e)}
                      className="campo-barra-pesquisa-cabecalho-sistema fonte-cor-1 fundo-cor-7"
                      type="text"
                      maxLength="150000"
                      value={
                        paginaComBuscaPorArquivo && nomeArquivo !== ''
                          ? nomeArquivo
                          : pesquisa
                      }
                      onChange={(e) => {
                        if (!paginaComBuscaPorArquivo || !buscaArquivo?.chave) {
                          setPesquisa(e.target.value)
                        } else if (paginaComBuscaPorArquivo) {
                          handleLimparPesquisa()
                        }
                      }}
                      placeholder={placeholder[manejador]}
                      onMouseEnter={() => {
                        setShowTooltipPesquisa(true)
                      }}
                      onMouseLeave={() => {
                        setShowTooltipPesquisa(false)
                      }}
                    />
                  </CustomTooltip>
                </div>
                <div className="coluna-barra-de-pesquisa-3">
                  <CustomTooltip text="Limpar">
                    <Button
                      className="botao-barra-pesquisa-limpar fundo-cor-7"
                      onClick={() => temConteudoBusca() ? handleLimparPesquisa() : null}
                    >
                      <Image
                        className="icone-botao-barra-pesquisa-limpar"
                        src={temConteudoBusca() ? limpar() : limparDesativado()}
                      />
                    </Button>
                  </CustomTooltip>
                </div>

                {paginaComBuscaPorArquivo && (
                  <BotaoBuscaPorArquivo
                    setRenderizarBuscaArquivo={setRenderizarBuscaArquivo}
                    iconeBotaoBuscarPorArquivo={iconeBotaoBuscarPorArquivo}
                  />
                )}

                {/* antes de abrir o dropdown dos separadores da busca */}
                <div className="coluna-barra-de-pesquisa-4">
                  <CustomTooltip text="Opções">
                    <Button
                      className="botao-barra-pesquisa-dropdown fundo-cor-7"
                      onClick={() =>
                        setRevelarSeperadorLinha(!revelarSeperadorLinha)
                      }
                    >
                      <Image
                        className="icone-botao-barra-pesquisa-dropdown"
                        src={setaDropdown()}
                      />
                    </Button>
                  </CustomTooltip>

                  {expandirDropDownSeparadorBusca && (
                    <>
                      <DropSeparadorLinha
                        setRevelarSeperadorLinha={setRevelarSeperadorLinha}
                        revelarSeperadorLinha={revelarSeperadorLinha}
                        className="posicionador-menu-filtros"
                      />
                      <div className="componente-modal-overlay-cabecalho" />
                    </>
                  )}
                </div>
              </>
            )}
          </div>
          {manejador === 'telaInicial' && (
            <Button
              disabled={!pesquisa}
              className="botao-filtros-acoes-cabecalho-sistema-home fundo-cor-busca-verde"
              onClick={() => handlePesquisar()}
            >
              <span className="label-filtros-acoes-cabecalho-sistema fonte-cor-14">
                Buscar
              </span>
            </Button>
          )}
          {manejador !== 'telaInicial' && (
            <div className="container-menus-filtros-acoes-cabecalho-sistema">
              {!esconderFiltros && (
                <div className="container-botao-filtros-cabecalho-sistema">
                  {revelarDropFiltros === false &&
                    (decryptJWT('codigoClienteErpAntigo') != '2933' ||
                      decryptJWT('codigoCliente') == '198') && (
                      <Button
                        className="botao-filtros-acoes-cabecalho-sistema fundo-cor-7"
                        onClick={() => handleAbrirFiltros()}
                      >
                        <span className="label-filtros-acoes-cabecalho-sistema fonte-cor-1">
                          Filtros
                        </span>
                        <Image
                          className="icone-filtros-cabecalho-sistema"
                          src={filtrarVerde()}
                        />
                      </Button>
                    )}

                  {revelarDropFiltros === true && (
                    <>
                      <DropFiltros
                        className="posicionador-menu-filtros"
                        setRevelarDropFiltros={setRevelarDropFiltros}
                        manejador={manejador}
                        toggleRevelarDropFiltros={toggleRevelarDropFiltros}
                      />
                      <div className="componente-modal-overlay-cabecalho" />
                    </>
                  )}
                </div>
              )}
              {arrPaginasComRelatorios.includes(manejador) &&
                menuRelatorios &&
                renderAcoesOuRelatorios('Relatórios')}
              {renderAcoesOuRelatorios('Ações')}
            </div>
          )}
        </div>
        {revelarMensagemCabecalhoSelecionada === true && (
          <div className="componente-modal-overlay-cabecalho">
            <div className="componente-modal">
              <Mensagem
                handleRevelarMensagens={() => handleRevelarMensagens(true)}
                tabela={false}
              />
            </div>
          </div>
        )}
        {revelarAlertaCabecalhoSelecionado === true && (
          <div className="componente-modal-overlay-cabecalho">
            <div className="componente-modal">
              <Mensagem
                handleRevelarAlertas={() => handleRevelarAlertas(true)}
                tabela={false}
              />
            </div>
          </div>
        )}
        <div className="grupo-cabecalho-sistema-3">
          <div>
            <CustomTooltip text="Alertas">
              <Button
                variant="secondary"
                className={
                  renderizarAlertas === true
                    ? 'botao-dropdown-alerta-cabecalho-sistema-2'
                    : 'botao-dropdown-alerta-cabecalho-sistema'
                }
                onClick={() => setRenderizarAlertas(!renderizarAlertas)}
              >
                <Image
                  className="icone-dropdown-alerta-cabecalho-sistema"
                  src={alerta()}
                />
                {contadorAlertasNaoLidos > 0 && (
                  <Badge
                    variant="danger"
                    className="badge-dropdown-alerta-cabecalho-sistema"
                  >
                    {contadorAlertasNaoLidos > 9
                      ? '9+'
                      : contadorAlertasNaoLidos}
                  </Badge>
                )}
              </Button>
            </CustomTooltip>
            {renderizarAlertas === true && (
              <div
                className="componente-modal-overlay-cabecalho"
                onClick={() => setRenderizarAlertas(!renderizarAlertas)}
              />
            )}
            {renderizarAlertas === true && (
              <div className="menu-dropdown-alerta-cabecalho-sistema fundo-cor-7">
                <div className="triangulo-menu-dropdown-alerta-cabecalho-sistema campo-select-triangulo-cor-2" />
                {rendersAlertasNaoLidos()}
                <Link to="/veye/mensagens">
                  <div onClick={() => setRenderizarAlertas(!renderizarAlertas)}>
                    <p className="label-ver-todos-dropdown-cabecalho-sistema">
                      Ver todas os alertas
                    </p>
                  </div>
                </Link>
              </div>
            )}
          </div>

          {permissaoVisualizarMensagens && (
            <div>
              <>
                <CustomTooltip text="Mensagens">
                  <Button
                    variant="secondary"
                    className={
                      renderizarMensagens === true
                        ? 'botao-dropdown-mensagem-cabecalho-sistema-2'
                        : 'botao-dropdown-mensagem-cabecalho-sistema'
                    }
                    onClick={() => {
                      setRenderizarMensagens(!renderizarMensagens)
                      setControleRenderizacaoMenuMensagens(true)
                    }}
                  >
                    <Image
                      className="icone-dropdown-mensagem-cabecalho-sistema"
                      src={email()}
                    />
                    {contadorMensagensNaoLidas > 0 && (
                      <Badge
                        variant="danger"
                        className="badge-dropdown-mensagem-cabecalho-sistema"
                      >
                        {' '}
                        {contadorMensagensNaoLidas > 9
                          ? '9+'
                          : contadorMensagensNaoLidas}
                      </Badge>
                    )}
                  </Button>
                </CustomTooltip>
                {renderizarMensagens === true && (
                  <div
                    className="componente-modal-overlay-cabecalho"
                    onClick={() => setRenderizarMensagens(!renderizarMensagens)}
                  />
                )}
                {renderizarMensagens === true && (
                  <div className="menu-dropdown-mensagem-cabecalho-sistema fundo-cor-7">
                    <div className="triangulo-menu-dropdown-mensagem-cabecalho-sistema campo-select-triangulo-cor-2" />
                    {rendersMensagensNaoLidas()}
                    <Link to="/veye/mensagens">
                      <div onClick={() => handleAbrirGridMensagens()}>
                        <p className="label-ver-todos-dropdown-cabecalho-sistema">
                          Ver todas as mensagens
                        </p>
                      </div>
                    </Link>
                  </div>
                )}
              </>
            </div>
          )}

          <div>
            <CustomTooltip text="Configurações">
              <Button
                variant="secondary"
                className={
                  renderizarConfiguracoes === true
                    ? 'botao-dropdown-configuracao-cabecalho-sistema-2'
                    : 'botao-dropdown-configuracao-cabecalho-sistema'
                }
                onClick={() =>
                  setRenderizarConfiguracoes(!renderizarConfiguracoes)
                }
              >
                <Image
                  className="icone-dropdown-configuracao-cabecalho-sistema"
                  src={configuracoes()}
                />
              </Button>
            </CustomTooltip>

            {renderizarConfiguracoes === true && (
              <div
                className="componente-modal-overlay-cabecalho"
                onClick={() =>
                  setRenderizarConfiguracoes(!renderizarConfiguracoes)
                }
              />
            )}
            {renderizarConfiguracoes === true && (
              <div className="menu-dropdown-configuracoes-cabecalho-sistema fundo-cor-7">
                <div className="triangulo-menu-dropdown-configuracoes-cabecalho-sistema campo-select-triangulo-cor-2" />
                {manejador == 'dspDispositivos' && (
                  <>
                    {permissaoExibirColunas && (
                      <>
                        <div className="item-menu-dropdown-cabecalho-sistema campo-select-opcao-1">
                          <span
                            className="label-item-menu-dropdown-cabecalho-sistema fonte-cor-1"
                            onClick={() => HandleRevelarExibirColunas()}
                          >
                            Exibir Colunas
                          </span>
                        </div>
                        <LinhaDivisoria />
                      </>
                    )}
                    {permissaoConfigurarGrupos && (
                      <>
                        <div className="item-menu-dropdown-cabecalho-sistema campo-select-opcao-1">
                          <span
                            className="label-item-menu-dropdown-cabecalho-sistema fonte-cor-1"
                            onClick={() => HandleRevelarConfigurarGrupo()}
                          >
                            Configurar Grupos
                          </span>
                        </div>
                        <LinhaDivisoria />
                      </>
                    )}
                  </>
                )}
                {manejador == 'fatDispositivos' && (
                  <>
                    {permissaoExibirColunas && (
                      <>
                        <div className="item-menu-dropdown-cabecalho-sistema campo-select-opcao-1">
                          <span
                            className="label-item-menu-dropdown-cabecalho-sistema fonte-cor-1"
                            onClick={() => HandleRevelarExibirColunas()}
                          >
                            Exibir Colunas
                          </span>
                        </div>
                        <LinhaDivisoria />
                      </>
                    )}
                  </>
                )}

                <div
                  className={
                    !isTemaEscuro
                      ? 'item-menu-dropdown-cabecalho-sistema-modo-noturno'
                      : 'item-menu-dropdown-cabecalho-sistema-modo-noturno gap-modo-claro'
                  }
                >
                  <span
                    htmlFor="custom-switch"
                    className="label-item-menu-dropdown-cabecalho-sistema fonte-cor-1"
                  >
                    {isTemaEscuro ? 'Modo claro' : 'Modo escuro'}
                  </span>
                  <CustomTooltip text="Clique para alternar entre o modo claro e o modo escuro">
                    <Switch
                      size="md"
                      color={isTemaEscuro ? 'gray' : 'dark'}
                      checked={isTemaEscuro}
                      disabled={trocandoTema}
                      onChange={handleTrocarTema}
                      onLabel={<FaSun size="0.8rem" color="#ffd43b" />}
                      offLabel={<FaMoon size="0.8rem" color="#228be6" />}
                      styles={{
                        body: {
                          marginBottom: 0
                        },
                        track: {
                          backgroundColor: isTemaEscuro ? '#000' : '#fff',
                          borderColor: isTemaEscuro ? '#333' : '#ccc',
                          cursor: 'pointer'
                        }
                      }}
                    />
                  </CustomTooltip>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

function mapStateToProps(state) {
  return { manejador: state.manejadorState.manejador }
}

export default connect(mapStateToProps)(CabecalhoSistema)
